import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { ParticipantsControlType } from '@gem/call/Model/callModel.types';
import { useTranslation } from '@gem/modules/i18n';

import { useCallContext } from '../../CallView.context';

interface IShowMembersButton {
  ongoingCall: Call;
  text: string;
  title: string;
}

export const useShowMembersButton = (): IShowMembersButton => {
  const context = useCallContext();
  const { t } = useTranslation();

  const presenter = useLocalObservable<IShowMembersButton>(() => ({
    get ongoingCall(): Call {
      return context.call;
    },

    get text(): string {
      const call = presenter.ongoingCall;
      const participantsCount = call.members.memberDevicesOnCallList.length;
      const membersCount = call.members.memberList.length;

      if (call.uiFeatures.participantsControlType === ParticipantsControlType.TotalNumber) {
        return `${participantsCount}`;
      }

      if (call.uiFeatures.participantsControlType === ParticipantsControlType.WithMaxNumber) {
        return `${participantsCount}/${membersCount}`;
      }

      return '';
    },

    get title(): string {
      return t('common_participants');
    },
  }));

  return presenter;
};
